// extracted by mini-css-extract-plugin
export default {"canvas":"Canvas_canvas__sA5-w"};